import React from 'react';
import { CHECK_IN_STATUS_PRESETS } from '../utils/webcheckinStatus';

/** Fill the editor draft only; the caller retains its explicit save action. */
const CheckInStatusPresets = ({ onSelect, disabled = false }) => (
  <div className="space-y-2 pb-2 border-b border-gray-100">
    <p className="text-xs font-medium text-gray-600">Quick fill</p>
    <div className="flex flex-wrap gap-1.5">
      {CHECK_IN_STATUS_PRESETS.map(({ label, ...values }) => (
        <button
          key={label}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(values)}
          title={values.message}
          className="text-xs text-left px-2.5 py-1.5 rounded-lg border border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {label}
        </button>
      ))}
    </div>
    <p className="text-xs text-gray-500">Fills the fields only. Review and save to apply.</p>
  </div>
);

export default CheckInStatusPresets;
